<template>
  <div>
    <loading v-if="loadingRender"></loading>

    <panel
      Title="تنظیمات کلی"
      Des="در این منو می‌توانید تنظیمات مربوط به درگاه های پرداخت و دیگر تنظیمات کلی در سامانه خود را انجام دهید."
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <net-pa-tab :Tabs="GatewayTabs"></net-pa-tab>
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div
                  ref="gatewayAnchor"
                  class="gw-toolbar-anchor"
                  :style="
                    toolbarPinned ? { height: toolbarHeight + 'px' } : null
                  "
                >
                  <div
                    ref="gatewaySentinel"
                    class="gw-sentinel"
                    aria-hidden="true"
                  ></div>
                  <div
                    class="gw-toolbar"
                    :class="{
                      'is-editing': EditMode,
                      'is-fixed': toolbarPinned,
                    }"
                    :style="toolbarPinned ? pinStyle : null"
                    dir="rtl"
                  >
                    <div class="gw-summary">
                      <span>{{ Menu.length }} درگاه</span>
                    </div>
                    <div class="gw-actions">
                      <template v-if="EditMode">
                        <button
                          type="button"
                          class="gw-btn gw-btn--ghost"
                          :disabled="$store.state.loading"
                          @click="cancelGatewayEdit"
                        >
                          انصراف
                        </button>
                        <button
                          type="button"
                          class="gw-btn gw-btn--save"
                          :disabled="$store.state.loading"
                          @click="updatemenu"
                        >
                          <i class="fas fa-check" aria-hidden="true"></i>
                          ثبت اطلاعات
                        </button>
                      </template>
                      <button
                        v-else
                        type="button"
                        class="gw-btn gw-btn--edit"
                        :disabled="Menu.length === 0"
                        @click="startGatewayEdit"
                      >
                        <i class="fas fa-edit" aria-hidden="true"></i>
                        اصلاح
                      </button>
                    </div>
                  </div>
                </div>
                <p v-if="Menu.length === 0" class="gw-empty">
                  موردی برای نمایش وجود ندارد
                </p>
                <div v-else class="gw-cards" dir="rtl">
                  <article
                    v-for="(item, index) in Menu"
                    :key="item.id != null ? item.id : index"
                    class="gw-card"
                    :class="{ 'is-editing': EditMode }"
                  >
                    <div class="gw-card__header">
                      <input
                        v-if="EditMode"
                        type="text"
                        class="gw-card__name-input"
                        v-model="item.persianName"
                        aria-label="نام درگاه"
                      />
                      <strong v-else class="gw-card__name">{{
                        item.persianName || "درگاه پرداخت"
                      }}</strong>
                      <span class="gw-card__badge">{{
                        item.gatewayCode || "درگاه " + (index + 1)
                      }}</span>
                    </div>
                    <div class="gw-card__fields">
                      <div class="gw-card__field">
                        <span>کد درگاه</span>
                        <input
                          v-if="EditMode"
                          type="text"
                          dir="ltr"
                          v-model="item.gatewayCode"
                          aria-label="کد درگاه"
                        />
                        <strong v-else dir="ltr">{{
                          item.gatewayCode || "—"
                        }}</strong>
                      </div>
                      <div class="gw-card__field">
                        <span>آدرس برگشت</span>
                        <input
                          v-if="EditMode"
                          type="text"
                          dir="ltr"
                          v-model="item.callBackUrl"
                          aria-label="آدرس برگشت"
                        />
                        <strong v-else dir="ltr" :title="item.callBackUrl">{{
                          item.callBackUrl || "—"
                        }}</strong>
                      </div>
                      <div class="gw-card__field">
                        <span>بازه فعالیت</span>
                        <input
                          v-if="EditMode"
                          type="text"
                          v-model="item.activeDay"
                          aria-label="بازه فعالیت درگاه"
                        />
                        <strong v-else>{{ item.activeDay || "—" }}</strong>
                      </div>
                    </div>
                    <div class="gw-card__flags">
                      <label
                        class="gw-card__flag"
                        :class="{ 'is-disabled': !EditMode }"
                      >
                        <span>پیش‌فرض</span>
                        <span class="gw-card__flag-ctrl">
                          <em
                            class="gw-card__flag-state"
                            :class="item.isDefault ? 'is-on' : 'is-off'"
                            >{{ item.isDefault ? "فعال" : "غیرفعال" }}</em
                          >
                          <span class="gw-switch">
                            <input
                              type="checkbox"
                              v-model="item.isDefault"
                              :disabled="!EditMode"
                              :aria-label="
                                'پیش‌فرض ' + (item.persianName || '')
                              "
                            />
                            <span
                              class="gw-switch__track"
                              aria-hidden="true"
                            ></span>
                          </span>
                        </span>
                      </label>
                      <label
                        class="gw-card__flag"
                        :class="{ 'is-disabled': !EditMode }"
                      >
                        <span>تغییر مبلغ</span>
                        <span class="gw-card__flag-ctrl">
                          <em
                            class="gw-card__flag-state"
                            :class="item.isFixVarizGhest ? 'is-on' : 'is-off'"
                            >{{
                              item.isFixVarizGhest ? "فعال" : "غیرفعال"
                            }}</em
                          >
                          <span class="gw-switch">
                            <input
                              type="checkbox"
                              v-model="item.isFixVarizGhest"
                              :disabled="!EditMode"
                              :aria-label="
                                'امکان تغییر مبالغ ' + (item.persianName || '')
                              "
                            />
                            <span
                              class="gw-switch__track"
                              aria-hidden="true"
                            ></span>
                          </span>
                        </span>
                      </label>
                      <label
                        class="gw-card__flag"
                        :class="{ 'is-disabled': !EditMode }"
                        title="عدم تغییر مبلغ در صورت داشتن جریمه"
                      >
                        <span>ثابت با جریمه</span>
                        <span class="gw-card__flag-ctrl">
                          <em
                            class="gw-card__flag-state"
                            :class="
                              item.IsFixVarizGhestHasJarime ? 'is-on' : 'is-off'
                            "
                            >{{
                              item.IsFixVarizGhestHasJarime
                                ? "فعال"
                                : "غیرفعال"
                            }}</em
                          >
                          <span class="gw-switch">
                            <input
                              type="checkbox"
                              v-model="item.IsFixVarizGhestHasJarime"
                              :disabled="!EditMode"
                              :aria-label="
                                'عدم تغییر مبلغ در صورت داشتن جریمه ' +
                                (item.persianName || '')
                              "
                            />
                            <span
                              class="gw-switch__track"
                              aria-hidden="true"
                            ></span>
                          </span>
                        </span>
                      </label>
                    </div>
                  </article>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div
            class="tab-pane fade acc-settings"
            id="nav-Account"
            role="tabpanel"
            aria-labelledby="nav-Account-tab"
          >
            <!-- Mahdodiat Enteghal -->
            <net-pa-card
              :IsMinus="true"
              :IdElement="'TransferSetting'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-exchange-alt"></i>
                  تنظیم محدودیت انتقال وجه
                </h6>
              </template>
              <template slot="content">
                <div class="acc-form">
                  <div class="acc-grid">
                    <div class="acc-field">
                      <label>انتخاب حساب</label>
                      <select
                        class="form-control Pointer acc-input"
                        v-model="DataAxios.wwwtblnoe"
                        @change="ChangeNoe(false)"
                      >
                        <option :value="-1">-- انتخاب حساب --</option>
                        <option
                          v-for="item in this.ListModel2"
                          :key="item.id"
                          :value="item"
                        >
                          <span>{{ item.desNoe }} </span>
                        </option>
                      </select>
                    </div>
                    <div
                      class="acc-field"
                      v-if="
                        DataAxios.wwwtblnoeId != -1 &&
                        DataAxios.wwwtblnoeId != null
                      "
                    >
                      <label>حداکثر مبلغ قبلی {{ $GetVahedPool() }}</label>
                      <input
                        class="form-control acc-input text-center 3ragham acc-input--muted"
                        disabled
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataAxios.wwwtblnoe.maxMabEnteghalDarMah"
                      />
                    </div>
                    <div
                      class="acc-field"
                      v-if="
                        DataAxios.wwwtblnoeId != -1 &&
                        DataAxios.wwwtblnoeId != null
                      "
                    >
                      <label>حداکثر مبلغ انتقال در روز {{ $GetVahedPool() }}</label>
                      <input
                        class="form-control acc-input text-center 3ragham"
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataAxios.Amount"
                      />
                    </div>
                  </div>
                  <div
                    class="acc-actions"
                    v-if="
                      DataAxios.wwwtblnoeId != -1 &&
                      DataAxios.wwwtblnoeId != null
                    "
                  >
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      @click="SetTaahodatList(false)"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Mahdodiat Bardasht -->
            <net-pa-card
              :IsMinus="true"
              :IdElement="'DebtorSetting'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-hand-holding-usd"></i>
                  تنظیم محدودیت برداشت وجه
                </h6>
              </template>
              <template slot="content">
                <div class="acc-form">
                  <div class="acc-grid">
                    <div class="acc-field">
                      <label>انتخاب حساب</label>
                      <select
                        class="form-control Pointer acc-input"
                        v-model="DataAxiosBardasht.wwwtblnoe"
                        @change="ChangeNoe(true)"
                      >
                        <option :value="-1">-- انتخاب حساب --</option>
                        <option
                          v-for="item in this.ListModel2"
                          :key="item.id"
                          :value="item"
                        >
                          <span>{{ item.desNoe }} </span>
                        </option>
                      </select>
                    </div>
                    <div
                      class="acc-field"
                      v-if="
                        DataAxiosBardasht.wwwtblnoeId != -1 &&
                        DataAxiosBardasht.wwwtblnoeId != null
                      "
                    >
                      <label>حداکثر مبلغ قبلی {{ $GetVahedPool() }}</label>
                      <input
                        class="form-control acc-input text-center 3ragham acc-input--muted"
                        disabled
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataAxiosBardasht.wwwtblnoe.maxMabBardashtDarRoz"
                      />
                    </div>
                    <div
                      class="acc-field"
                      v-if="
                        DataAxiosBardasht.wwwtblnoeId != -1 &&
                        DataAxiosBardasht.wwwtblnoeId != null
                      "
                    >
                      <label>حداکثر مبلغ انتقال در روز {{ $GetVahedPool() }}</label>
                      <input
                        class="form-control acc-input text-center 3ragham"
                        @keyup="$PutCommatoInput()"
                        type="text"
                        v-model="DataAxiosBardasht.Amount"
                      />
                    </div>
                    <label
                      class="acc-switch"
                      v-if="
                        $session.get('CustCode') == '948' &&
                        DataAxiosBardasht.wwwtblnoeId != -1 &&
                        DataAxiosBardasht.wwwtblnoeId != null
                      "
                    >
                      <span>برداشت وجه در صورت تسهیلات معوق</span>
                      <span class="gw-switch">
                        <input
                          type="checkbox"
                          id="withdrawalIfLoanIsDelayed"
                          v-model="
                            DataAxiosBardasht.wwwtblnoe.withdrawalIfLoanIsDelayed
                          "
                          aria-label="برداشت وجه در صورت تسهیلات معوق"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </span>
                    </label>
                  </div>
                  <div
                    class="acc-actions"
                    v-if="
                      DataAxiosBardasht.wwwtblnoeId != -1 &&
                      DataAxiosBardasht.wwwtblnoeId != null
                    "
                  >
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      @click="SetTaahodatList(true)"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Tanzimat Peyvast hesabha -->
            <net-pa-card
              :IsMinus="true"
              :IdElement="'Atachment'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-paperclip"></i>
                  تنظیم پیوست حساب‌ها
                </h6>
              </template>
              <template slot="content">
                <div class="acc-form">
                  <p class="acc-hint">
                    این بخش بهتر است توسط تیم برنامه‌نویس شرکت پاسارگاد تنظیم شود.
                  </p>
                  <div class="acc-grid">
                    <div class="acc-field">
                      <label>انتخاب حساب</label>
                      <select
                        class="form-control Pointer acc-input"
                        v-model="DataAxiosTashilat.wwwtblnoe"
                        @change="ChangeTashilatNoe()"
                      >
                        <option :value="-1">-- انتخاب حساب --</option>
                        <option
                          v-for="item in this.ListTashilat"
                          :key="item.id"
                          :value="item"
                        >
                          <span>{{ item.desNoe }} </span>
                        </option>
                      </select>
                    </div>
                    <div class="acc-field acc-field--span2">
                      <label>نام SP (پیوستی محاسبات) مربوطه</label>
                      <input
                        class="form-control acc-input text-left"
                        dir="ltr"
                        type="text"
                        v-model="DataAxiosTashilat.SP"
                      />
                    </div>
                    <div class="acc-field acc-field--span2">
                      <label>پیغام در صورت نفر صفر بودن بر حسب امتیاز مکتسبه</label>
                      <input
                        class="form-control acc-input"
                        v-model="DataAxiosTashilat.MessageZeroScore"
                      />
                    </div>
                    <label class="acc-switch">
                      <span>نمایش نفر صفر بر حسب امتیاز مکتسبه</span>
                      <span class="gw-switch">
                        <input
                          type="checkbox"
                          id="isShowMessage"
                          v-model="DataAxiosTashilat.ShowMessageZeroScore"
                          aria-label="نمایش نفر صفر بر حسب امتیاز مکتسبه"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </span>
                    </label>
                    <label class="acc-switch">
                      <span>نمایش امتیاز</span>
                      <span class="gw-switch">
                        <input
                          type="checkbox"
                          id="IsShowScore"
                          v-model="DataAxiosTashilat.ShowScore"
                          aria-label="نمایش امتیاز"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </span>
                    </label>
                  </div>
                  <div class="acc-actions">
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      @click="SetTashilatList"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Tanzimat Brge Saham -->
            <net-pa-card
              v-if="
                Number(
                  $session.get('UserInfoNetPa').custCode == 868 ||
                    $session.get('UserInfoNetPa').custCode == 574 ||
                    $session.get('UserInfoNetPa').custCode == 886 ||
                    $session.get('UserInfoNetPa').custCode == 932 ||
                    $session.get('UserInfoNetPa').custCode == 352 ||
                    $session.get('UserInfoNetPa').custCode == 850 ||
                    $session.get('UserInfoNetPa').custCode == 8002 ||
                    $session.get('UserInfoNetPa').custCode == 874,
                )
              "
              :IsMinus="true"
              :IdElement="'Saham'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-file-alt"></i>
                  تنظیم برگه سهام
                </h6>
              </template>
              <template slot="content">
                <div id="BargeSaham" class="acc-form acc-form--saham">
                  <div class="acc-saham">
                    <section class="acc-saham-panel">
                      <h6 class="acc-saham-panel__title">اطلاعات برگه سهام</h6>
                      <div class="acc-grid acc-grid--2">
                      <div class="acc-field">
                        <label>انتخاب حساب</label>
                        <select
                          class="form-control Pointer required acc-input"
                          v-model="DataAxiosSaham.wwwtblNoeId"
                        >
                          <option
                            v-for="item in this.ListTashilat"
                            :key="item.id"
                            :value="item.id"
                          >
                            <span>{{ item.desNoe }} </span>
                          </option>
                        </select>
                      </div>
                      <div class="acc-field">
                        <label>شماره ثبت</label>
                        <input
                          class="form-control acc-input text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.shomareSabt"
                        />
                      </div>
                      <div class="acc-field acc-field--date">
                        <label>تاریخ ثبت</label>
                        <date-picker
                          input-class="required"
                          :editable="true"
                          :auto-submit="true"
                          color="#05b8c8"
                          v-model="DataAxiosSaham.tarixSabt"
                        >
                        </date-picker>
                      </div>
                      <div class="acc-field">
                        <label>ارزش هر سهم {{ $GetVahedPool() }}</label>
                        <input
                          class="form-control acc-input text-center 3ragham required"
                          dir="ltr"
                          type="text"
                          @keyup="$PutCommatoInput()"
                          v-model="DataAxiosSaham.arzeshHarSahm"
                        />
                      </div>
                      <div class="acc-field">
                        <label>مشخصات رئیس هیئت مدیره</label>
                        <input
                          class="form-control acc-input text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.pishNevis1"
                        />
                      </div>
                      <div class="acc-field">
                        <label>مشخصات مدیر عامل</label>
                        <input
                          class="form-control acc-input text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.pishNevis2"
                        />
                      </div>
                      <div class="acc-field">
                        <label>سریال</label>
                        <input
                          class="form-control acc-input text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.serialNumber"
                        />
                      </div>
                      <div class="acc-field">
                        <label>شناسه ملی</label>
                        <input
                          class="form-control acc-input text-center required"
                          dir="ltr"
                          type="text"
                          v-model="DataAxiosSaham.shenaseMeli"
                        />
                      </div>
                      <div class="acc-field acc-field--wide">
                        <label>پیغام در صورت نفر صفر بودن بر حسب امتیاز مکتسبه</label>
                        <input
                          class="form-control acc-input"
                          v-model="DataAxiosSaham.MessageZeroScore"
                        />
                      </div>
                      <label class="acc-switch">
                        <span>نمایش نفر صفر بر حسب امتیاز مکتسبه</span>
                        <span class="gw-switch">
                          <input
                            type="checkbox"
                            id="isShowMessageSaham"
                            v-model="DataAxiosSaham.ShowMessageZeroScore"
                            aria-label="نمایش نفر صفر بر حسب امتیاز مکتسبه"
                          />
                          <span class="gw-switch__track" aria-hidden="true"></span>
                        </span>
                      </label>
                      <label class="acc-switch">
                        <span>نمایش امتیاز</span>
                        <span class="gw-switch">
                          <input
                            type="checkbox"
                            id="isShowScore"
                            v-model="DataAxiosSaham.ShowScore"
                            aria-label="نمایش امتیاز"
                          />
                          <span class="gw-switch__track" aria-hidden="true"></span>
                        </span>
                      </label>
                    </div>
                    </section>
                    <section class="acc-saham-panel">
                      <h6 class="acc-saham-panel__title">تصویر و امضا</h6>
                      <div class="acc-uploaders">
                        <div
                          class="acc-saham-upload"
                          :class="{
                            'has-file': !!GetAddress(181070512),
                          }"
                          @click="onSahamUploadClick($event, 'Logo')"
                        >
                          <div class="acc-saham-upload__text">
                            <strong class="acc-saham-upload__title"
                              >تصویر لوگو برگه سهام</strong
                            >
                            <span class="acc-saham-upload__hint">{{
                              GetAddress(181070512)
                                ? "برای تغییر تصویر کلیک کنید"
                                : "برای انتخاب تصویر کلیک کنید"
                            }}</span>
                          </div>
                          <div
                            class="acc-saham-upload__preview"
                            title="انتخاب تصویر"
                          >
                            <i
                              class="fas fa-camera acc-saham-upload__icon"
                              aria-hidden="true"
                            ></i>
                            <i
                              class="fas fa-plus acc-saham-upload__plus"
                              aria-hidden="true"
                            ></i>
                            <uploader
                              :Idu="'Logo'"
                              v-if="$store.state.renderComponent"
                              :base64="GetBase(181070512)"
                              @Done="GetFile"
                              :attachId="GetId(181070512)"
                              :address="GetAddress(181070512)"
                              :grp="181070512"
                              :title="'تصویر لوگو برگه سهام'"
                              :MasterId="DataAxiosSaham.id"
                              :TableName="'wwwtblTanzimat'"
                            ></uploader>
                          </div>
                        </div>
                        <div
                          class="acc-saham-upload"
                          :class="{
                            'has-file': !!GetAddress(181070510),
                          }"
                          @click="onSahamUploadClick($event, 'Emza1')"
                        >
                          <div class="acc-saham-upload__text">
                            <strong class="acc-saham-upload__title"
                              >امضا اول</strong
                            >
                            <span class="acc-saham-upload__hint">{{
                              GetAddress(181070510)
                                ? "برای تغییر تصویر کلیک کنید"
                                : "برای انتخاب تصویر کلیک کنید"
                            }}</span>
                          </div>
                          <div
                            class="acc-saham-upload__preview"
                            title="انتخاب تصویر"
                          >
                            <i
                              class="fas fa-camera acc-saham-upload__icon"
                              aria-hidden="true"
                            ></i>
                            <i
                              class="fas fa-plus acc-saham-upload__plus"
                              aria-hidden="true"
                            ></i>
                            <uploader
                              :Idu="'Emza1'"
                              v-if="$store.state.renderComponent"
                              :base64="GetBase(181070510)"
                              @Done="GetFile"
                              :attachId="GetId(181070510)"
                              :address="GetAddress(181070510)"
                              :grp="181070510"
                              :title="'امضا اول'"
                              :MasterId="DataAxiosSaham.id"
                              :TableName="'wwwtblTanzimat'"
                            ></uploader>
                          </div>
                        </div>
                        <div
                          class="acc-saham-upload"
                          :class="{
                            'has-file': !!GetAddress(181070511),
                          }"
                          @click="onSahamUploadClick($event, 'Emza2')"
                        >
                          <div class="acc-saham-upload__text">
                            <strong class="acc-saham-upload__title"
                              >امضا دوم</strong
                            >
                            <span class="acc-saham-upload__hint">{{
                              GetAddress(181070511)
                                ? "برای تغییر تصویر کلیک کنید"
                                : "برای انتخاب تصویر کلیک کنید"
                            }}</span>
                          </div>
                          <div
                            class="acc-saham-upload__preview"
                            title="انتخاب تصویر"
                          >
                            <i
                              class="fas fa-camera acc-saham-upload__icon"
                              aria-hidden="true"
                            ></i>
                            <i
                              class="fas fa-plus acc-saham-upload__plus"
                              aria-hidden="true"
                            ></i>
                            <uploader
                              :Idu="'Emza2'"
                              v-if="$store.state.renderComponent"
                              :base64="GetBase(181070511)"
                              @Done="GetFile"
                              :attachId="GetId(181070511)"
                              :address="GetAddress(181070511)"
                              :grp="181070511"
                              :title="'امضا دوم'"
                              :MasterId="DataAxiosSaham.id"
                              :TableName="'wwwtblTanzimat'"
                            ></uploader>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div class="acc-actions">
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      @click="SetSaham"
                    >
                      ثبت اطلاعات برگه سهام
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
            <!-- Nemayesh Buttons Variz-Bardasht-Gardesh -->
            <net-pa-card
              v-if="
                Number(
                  $session.get('UserInfoNetPa').custCode == 868 ||
                    $session.get('UserInfoNetPa').custCode == 8002 ||
                    $session.get('UserInfoNetPa').custCode == 886 ||
                    $session.get('UserInfoNetPa').custCode == 574 ||
                    $session.get('UserInfoNetPa').custCode == 932,
                )
              "
              :IsMinus="true"
              :IdElement="'SettingsButton'"
              :IsCollapse="true"
            >
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-sliders-h"></i>
                  تنظیم واریز | برداشت | گردش حساب‌ها
                </h6>
              </template>
              <template slot="content">
                <div class="acc-form">
                  <div class="acc-grid">
                    <div class="acc-field">
                      <label>انتخاب حساب</label>
                      <select
                        class="form-control Pointer acc-input"
                        v-model="DataAxiosButtons.wwwtblnoe"
                        @change="ChangeWwwtblNoeButtons"
                      >
                        <option :value="null">-- انتخاب حساب --</option>
                        <option
                          v-for="item in this.ListTashilat"
                          :key="item.id"
                          :value="item"
                        >
                          <span>{{ item.desNoe }} </span>
                        </option>
                      </select>
                    </div>
                    <label
                      class="acc-switch acc-switch--start"
                      v-if="DataAxiosButtons.wwwtblnoe != null"
                    >
                      <span>نمایش دکمه واریز</span>
                      <span class="gw-switch">
                        <input
                          type="checkbox"
                          id="isPayment"
                          v-model="DataAxiosButtons.isPayment"
                          aria-label="نمایش دکمه واریز"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </span>
                    </label>
                    <label
                      class="acc-switch"
                      v-if="DataAxiosButtons.wwwtblnoe != null"
                    >
                      <span>نمایش دکمه برداشت</span>
                      <span class="gw-switch">
                        <input
                          type="checkbox"
                          id="isDeptor"
                          v-model="DataAxiosButtons.isDebtor"
                          aria-label="نمایش دکمه برداشت"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </span>
                    </label>
                    <label
                      class="acc-switch"
                      v-if="DataAxiosButtons.wwwtblnoe != null"
                    >
                      <span>نمایش دکمه گردش</span>
                      <span class="gw-switch">
                        <input
                          type="checkbox"
                          id="isTernover"
                          v-model="DataAxiosButtons.isTurnover"
                          aria-label="نمایش دکمه گردش"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </span>
                    </label>
                  </div>
                  <div
                    class="acc-actions"
                    v-if="DataAxiosButtons.wwwtblnoe != null"
                  >
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      @click="SetSettingButtons"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div
            class="tab-pane fade"
            id="nav-Account-Setting"
            role="tabpanel"
            aria-labelledby="nav-Account-Setting-tab"
          >
            <net-pa-card
              :IsMinus="false"
              :IdElement="'AccountSetting'"
              :IsCollapse="false"
            >
              <template slot="header">
                <h6>تنظیمات حساب بانکی جهت نمایش در فیش</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div class="col-md-3 col-12">
                    <small>نام بانک</small>
                    <select
                      class="form-control"
                      v-model="Account.Id"
                      @change="GetResultBank"
                    >
                      <option selected :value="0">
                        بانک خودرا انتخاب کنید
                      </option>
                      <option
                        v-for="(item, key) in BankList"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.bankName }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 col-12" v-if="Account.Id > 0">
                    <small>شماره حساب</small>
                    <input
                      class="form-control text-left"
                      v-model="Account.HesabNo"
                      type="text"
                      @keypress="$ValidNumber($event, 20, false)"
                    />
                  </div>
                  <div class="col-md-6 col-12" v-if="Account.Id > 0">
                    <small>اطلاعات حساب</small>
                    <input
                      class="form-control text-right"
                      v-model="Account.BankDetail"
                      placeholder="حقیقی : نام شخص | حقوقی : نام شرکت یا سازمان"
                    />
                  </div>
                  <div class="col-md-3 col-12 mt-2" v-if="Account.Id > 0">
                    <small>شماره کارت</small>
                    <input
                      class="form-control text-center"
                      v-model="Account.CardNo"
                      type="text"
                      v-mask="'####-####-####-####'"
                    />
                  </div>
                  <div class="col-md-5 col-12 mt-2" v-if="Account.Id > 0">
                    <small>شماره شبا</small>
                    <input
                      class="form-control text-center"
                      v-model="Account.ShebaNo"
                      type="text"
                      v-mask="'IR########################'"
                    />
                  </div>
                  <div class="col-md-4 col-12 mt-2" v-if="Account.Id > 0">
                    <button
                      class="btn btn-success mt-3 float-left"
                      @click="SetTableSetting"
                    >
                      ثبت اطلاعات حساب
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <div
            class="tab-pane fade"
            id="nav-Settings"
            role="tabpanel"
            aria-labelledby="nav-Settings-tab"
          >
            <net-pa-card :Compact="true">
              <template slot="content">
                <div class="sys-list" dir="rtl">
                  <div class="sys-row">
                    <div class="sys-copy">
                      <span class="sys-title">حالت امنیتی تغییر رمز کاربران</span>
                      <span class="sys-hint">{{
                        ActivePasswordSecurityMode
                          ? "امنیتی و سختگیرانه بر اساس حروف کوچک و بزرگ و اعداد"
                          : "غیر امنیتی و راحت (پیشنهاد نمی‌شود)"
                      }}</span>
                    </div>
                    <div class="sys-actions">
                      <span
                        class="sys-state"
                        :class="ActivePasswordSecurityMode ? 'is-on' : 'is-off'"
                      >
                        {{ ActivePasswordSecurityMode ? "فعال" : "غیرفعال" }}
                      </span>
                      <label class="gw-switch">
                        <input
                          type="checkbox"
                          id="SecurityPass"
                          v-model="ActivePasswordSecurityMode"
                          @change="ChangeActivePasswordSecurityMode($event)"
                          aria-label="حالت امنیتی تغییر رمز کاربران"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </label>
                    </div>
                  </div>

                  <div class="sys-row">
                    <div class="sys-copy">
                      <span class="sys-title">تصویر صفحه ورود</span>
                      <span class="sys-hint">{{
                        loginDefaultImageMode
                          ? "تصویر پیش‌فرض سامانه نمایش داده می‌شود"
                          : "تصویر دلخواه — فرمت jpg و ابعاد ۵۰۰×۷۰۰ پیکسل"
                      }}</span>
                      <span
                        v-if="fileinfo.name && !loginDefaultImageMode"
                        class="sys-file"
                        >{{ fileinfo.name }}</span
                      >
                    </div>
                    <div class="sys-actions">
                      <button
                        v-if="!loginDefaultImageMode"
                        type="button"
                        class="gw-btn gw-btn--edit"
                        @click.prevent="clickUploader()"
                      >
                        <i class="fas fa-upload" aria-hidden="true"></i>
                        بارگذاری تصویر
                      </button>
                      <span
                        class="sys-state"
                        :class="loginDefaultImageMode ? 'is-on' : 'is-off'"
                      >
                        {{ loginDefaultImageMode ? "پیش‌فرض" : "دلخواه" }}
                      </span>
                      <label class="gw-switch">
                        <input
                          type="checkbox"
                          id="loginPhoto"
                          v-model="loginDefaultImageMode"
                          @change="setLoginImgMode()"
                          aria-label="تصویر صفحه ورود"
                        />
                        <span class="gw-switch__track" aria-hidden="true"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <input
                  type="file"
                  @change="changefile($event)"
                  class="d-none"
                  id="Uploader"
                  accept=".gif,.jpg,.jpeg,.png"
                />
              </template>
            </net-pa-card>
          </div>
          <!--******************************************************************************************-->
          <div
            class="tab-pane fade acc-settings"
            id="nav-Robot-Setting"
            role="tabpanel"
            aria-labelledby="nav-Robot-Setting-tab"
          >
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right">
                  <i class="fas fa-robot"></i>
                  تنظیمات بازو
                </h6>
              </template>
              <template slot="content">
                <div class="acc-form">
                  <div class="acc-grid">
                    <div class="acc-field acc-field--span2">
                      <label>توکن بازو</label>
                      <input
                        class="form-control acc-input text-right"
                        placeholder="توکن بازو خود را وارد کنید"
                        v-model="botSetting_Token"
                        @keypress="$BlockSuspiciousInput($event, 100)"
                        @keyup="$BlockSuspiciousInput($event, 100)"
                      />
                    </div>
                    <div class="acc-field">
                      <label>نام کاربری بازو</label>
                      <input
                        class="form-control acc-input text-right"
                        v-model="botSetting_UserName"
                        @keypress="$BlockSuspiciousInput($event, 50)"
                        @keyup="$BlockSuspiciousInput($event, 50)"
                      />
                    </div>
                    <div class="acc-field acc-field--wide">
                      <label>درباره ما</label>
                      <textarea
                        class="form-control acc-input acc-notes text-right"
                        placeholder="متن درباره ما نمایش داده شده در بازو"
                        v-model="botSetting_AboutUs"
                        @keypress="$BlockSuspiciousInput($event, 2000)"
                        @keyup="$BlockSuspiciousInput($event, 2000)"
                      ></textarea>
                    </div>
                  </div>
                  <div class="acc-actions">
                    <button
                      type="button"
                      class="gw-btn gw-btn--save"
                      @click="setRobot()"
                    >
                      اعمال تغییرات
                    </button>
                  </div>
                </div>
              </template>
            </net-pa-card>
          </div>
          <!-- <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import NetPaTab from "../Tools/NetPa/NetPaTab.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import uploader from "./Componenets/NetpaUploader.vue";
import Loading from "../Tools/NetPa/Loading.vue";

export default {
  components: {
    NetPaCard,
    NetPaTab,
    Panel,
    uploader,
    Loading,
  },
  data() {
    return {
      EnableRobot: "",
      botSetting_Token: "",
      botSetting_UserName: "",
      botSetting_AboutUs: "",
      BankList: [],
      file: [],
      Menu: [],
      EditMode: false,
      gatewaySnapshot: null,
      toolbarPinned: false,
      toolbarHeight: 0,
      pinStyle: null,
      DataAxios: { wwwtblnoe: -1 },
      DataAxiosBardasht: { wwwtblnoe: -1 },
      ListModel2: null,
      ListTashilat: null,
      DataAxiosTashilat: { wwwtblnoe: -1 },
      DataAxiosSaham: {},
      DataAxiosButtons: {
        wwwtblnoe: null,
        wwwtblnoeId: null,
        isPayment: true,
        isDebtor: true,
        isTurnover: true,
      },
      Account: {
        HesabNo: "",
        ShebaNo: "",
        CardNo: "",
        BankName: "",
        BankDetail: "",
        Id: 0,
      },
      ActivePasswordSecurityMode: this.$GetActivePasswordSecurityMode(),
      fileinfo: {},
      showUploaderLogin: false,
      loadingRender: false,
      loginDefaultImageMode: this.$getLoginImgMode(),
      IsImgLoginUploaded: false,
      DataAxiosUpload: {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetTblCustomer/UploadLoginImage",
        Token: this.$session.get("TokenNetPa"), // شماعی 1405/07/14 : API حالا فقط کارمند صندوق را قبول می‌کند
      },
    };
  },
  computed: {
    GatewayTabs() {
      const tabs = [
        { id: "nav-home", title: "تنظیمات درگاه پرداخت" },
        { id: "nav-Account", title: "تنظیمات حساب ها" },
        { id: "nav-Settings", title: "تنظیمات سامانه" },
      ];
      if (this.$session.get("CustCode") == "945") {
        tabs.push({ id: "nav-Account-Setting", title: "تنظیمات حساب بانکی" });
      }
      if (this.EnableRobot) {
        tabs.push({ id: "nav-Robot-Setting", title: "تنظیمات بازو" });
      }
      return tabs;
    },
  },
  methods: {
    observeGatewayToolbar() {
      if (
        typeof IntersectionObserver === "undefined" ||
        !this.$refs.gatewaySentinel
      ) {
        return;
      }
      this.toolbarObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const paneHidden =
            entry.boundingClientRect.width === 0 &&
            entry.boundingClientRect.height === 0;
          if (paneHidden) {
            this.toolbarPinned = false;
            return;
          }
          const shouldPin =
            !entry.isIntersecting && entry.boundingClientRect.top < 8;
          if (shouldPin === this.toolbarPinned) {
            if (shouldPin) this.updateGatewayPinBox();
            return;
          }
          if (shouldPin) this.updateGatewayPinBox();
          this.toolbarPinned = shouldPin;
        },
        { threshold: 0 },
      );
      this.toolbarObserver.observe(this.$refs.gatewaySentinel);
      if (typeof ResizeObserver !== "undefined" && this.$refs.gatewayAnchor) {
        this.anchorResizeObserver = new ResizeObserver(() => {
          if (this.toolbarPinned) this.updateGatewayPinBox();
        });
        this.anchorResizeObserver.observe(this.$refs.gatewayAnchor);
      }
    },
    updateGatewayPinBox() {
      const anchor = this.$refs.gatewayAnchor;
      const toolbar = anchor && anchor.querySelector(".gw-toolbar");
      if (!anchor || !toolbar) return;
      const rect = anchor.getBoundingClientRect();
      this.toolbarHeight = toolbar.offsetHeight;
      this.pinStyle = {
        top: "12px",
        left: rect.left + "px",
        width: rect.width + "px",
      };
    },
    startGatewayEdit() {
      this.gatewaySnapshot = JSON.parse(JSON.stringify(this.Menu));
      this.EditMode = true;
    },
    cancelGatewayEdit() {
      if (this.gatewaySnapshot) {
        this.Menu = JSON.parse(JSON.stringify(this.gatewaySnapshot));
      }
      this.EditMode = false;
    },
    readMenus() {
      var DataAxiosRead = {
        ArryfildValue: {
          shobeId: this.$session.get("UserInfoNetPa").wwwtblShobeId,
        },
        Method: "GET",
        Action: "GatewayOld",
      };
      this.$GetData_Header(DataAxiosRead).then((data) => {
        this.Menu = data.data;
      });
    },
    updatemenu() {
      this.$store.state.loading = true;
      var DataAxiosUpdate = {
        ArryfildValue: {},
        Method: "Post",
        Action: "UpdateGateway",
      };
      DataAxiosUpdate.ArryfildValue = this.Menu;
      this.$PutData_Body(DataAxiosUpdate).then((data) => {
        this.$store.state.loading = false;
        if (data.status == "Ok") {
          this.$mySweetDefault(
            "عملیات موفق!",
            "تغییرات با موفقیت ذخیره شد. برای اعمال یکبار از برنامه خارج شوید و دوباره وارد شوید",
            "success",
            3000,
          );
        } else {
          this.$mySweetDefault(
            "خطا!",
            "در ثبت اطلاعات مشکلی رخ داده است. لطفا دوباره تلاش کنید",
            "danger",
            2000,
          );
        }
        this.EditMode = !this.EditMode;
        this.readMenus();
      });
    },
    GetTaahodatList() {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        this.ListModel2 = data.data;
      });
    },
    SetTaahodatList(IsBardasht) {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/SetSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      if (IsBardasht) {
        formData.append("wwwtblNoeId", this.DataAxiosBardasht.wwwtblnoeId);
        formData.append(
          "WithdrawalIfLoanIsDelayed",
          this.$session.get("CustCode") == "948"
            ? this.DataAxiosBardasht.wwwtblnoe.withdrawalIfLoanIsDelayed
            : false,
        );

        formData.append(
          "Amount",
          this.DataAxiosBardasht.Amount != "" &&
            this.DataAxiosBardasht.Amount != null
            ? this.DataAxiosBardasht.Amount.replace(/,/g, "").replace(/\./g, "")
            : this.DataAxiosBardasht.wwwtblnoe.maxMabBardashtDarRoz,
        );
      } else {
        formData.append("wwwtblNoeId", this.DataAxios.wwwtblnoeId);
        formData.append(
          "Amount",
          this.DataAxios.Amount.replace(/,/g, "").replace(/\./g, ""),
        );
      }

      formData.append("IsBardasht", IsBardasht);
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        if (data.status == "Ok") {
          this.GetTaahodatList();
          this.DataAxios = {};
          this.DataAxiosBardasht = { wwwtblnoe: -1 };
          this.$mySweetDefaultTost(
            " ثبت موفق",
            "تغییرات شما با موفقیت ثبت گردید",
            "success",
            2000,
          );
        }
      });
    },
    ChangeNoe(IsBardasht) {
      if (IsBardasht) {
        this.DataAxiosBardasht.wwwtblnoeId =
          this.DataAxiosBardasht.wwwtblnoe.id;
        this.DataAxiosBardasht.wwwtblnoe.maxMabEnteghalDarMah =
          this.$Comma3ragham(
            this.DataAxiosBardasht.wwwtblnoe.maxMabEnteghalDarMah,
          );
      } else {
        this.DataAxios.wwwtblnoeId = this.DataAxios.wwwtblnoe.id;
        this.DataAxios.wwwtblnoe.maxMabEnteghalDarMah = this.$Comma3ragham(
          this.DataAxios.wwwtblnoe.maxMabEnteghalDarMah,
        );
      }
    },
    GetTashilatList() {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/GettblNoe",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("NoeId", 2);
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        this.ListTashilat = data.data;
      });
    },
    SetTashilatList() {
      var DataAxios_Noe = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/SetSettingsTashilat",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblNoeId", this.DataAxiosTashilat.wwwtblnoeId);
      formData.append("SP", this.DataAxiosTashilat.SP);
      formData.append(
        "MessageZeroScore",
        this.DataAxiosTashilat.MessageZeroScore,
      );
      formData.append(
        "ShowMessageZeroScore",
        this.DataAxiosTashilat.ShowMessageZeroScore,
      );
      formData.append("ShowScore", this.DataAxiosTashilat.ShowScore);
      DataAxios_Noe.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Noe).then((data) => {
        if (data.status == "Ok") {
          this.GetTashilatList();
          this.DataAxiosTashilat = {};
          this.$mySweetDefaultTost(
            " ثبت موفق",
            "تغییرات شما با موفقیت ثبت گردید",
            "success",
            2000,
          );
        } else {
          this.$mySweetDefaultTost("خطایی رخ داده", data.msg, "danger", 2000);
        }
      });
    },
    ChangeTashilatNoe() {
      if (this.DataAxiosTashilat.wwwtblnoe.id) {
        this.DataAxiosTashilat.wwwtblnoeId =
          this.DataAxiosTashilat.wwwtblnoe.id;
        this.DataAxiosTashilat.SP =
          this.DataAxiosTashilat.wwwtblnoe.spName.trim();
        this.DataAxiosTashilat.MessageZeroScore =
          this.DataAxiosTashilat.wwwtblnoe.messageZeroScore.trim();
        this.DataAxiosTashilat.ShowMessageZeroScore =
          this.DataAxiosTashilat.wwwtblnoe.showMessageZeroScore;
        this.DataAxiosTashilat.ShowScore =
          this.DataAxiosTashilat.wwwtblnoe.showScore;
        //console.log('😎 ~ ChangeTashilatNoe ~ this.DataAxiosTashilat:', this.DataAxiosTashilat)
      } else {
        this.DataAxiosTashilat = {};
      }
    },
    GetFile() {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: this.DataAxiosSaham.id,
          tableName: "wwwtblTanzimat",
        },
      };
      this.$PostData(dataAxios).then((result) => {
        if (result.data[0]) {
          if (result.data[0].wwwtblcomboidgrp328 == 181070512) {
            this.DataAxiosSaham.wwwtblImageIdLogo = result.data[0].id;
          } else if (result.data[0].wwwtblcomboidgrp328 == 181070510) {
            this.DataAxiosSaham.wwwtblImageIdEmza1 = result.data[0].id;
          } else if (result.data[0].wwwtblcomboidgrp328 == 181070511) {
            this.DataAxiosSaham.wwwtblImageIdEmza2 = result.data[0].id;
          }
        }
        this.file = result.data;
        this.$store.state.renderComponent = false;
        this.$nextTick(() => {
          this.$store.state.renderComponent = true;
        });
      });
    },
    GetBase(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary;
      } else {
        return null;
      }
    },
    GetAddress(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        if (
          binary.filename.indexOf(".PDF") > 0 ||
          binary.filename.indexOf(".pdf") > 0
        ) {
          return "/Image/PdfFile.png";
        }
        if (
          binary.filename.indexOf(".zip") > 0 ||
          binary.filename.indexOf(".rar") > 0
        ) {
          return "/Image/ZipFile.png";
        }
        return "data:image/png;base64," + binary.binary;
      } else {
        return null;
      }
    },
    GetId(id) {
      var binary = this.file.find((x) => x.wwwtblcomboidgrp328 == id);
      if (binary) {
        return binary.id;
      } else {
        return null;
      }
    },
    SetSaham() {
      if (this.$ValidForm("BargeSaham")) {
        var DataAxios_NoeSaham = {
          ArryfildValue: "",
          Method: "Post",
          Action: "TanzimatNoe/UpdateSaham",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("wwwtblNoeId", this.DataAxiosSaham.wwwtblNoeId);
        formData.append("ShomareSabt", this.DataAxiosSaham.shomareSabt);
        formData.append("TarixSabt", this.DataAxiosSaham.tarixSabt);
        formData.append("ArzeshHarSahm", this.DataAxiosSaham.arzeshHarSahm);
        formData.append("PishNevis1", this.DataAxiosSaham.pishNevis1);
        formData.append("PishNevis2", this.DataAxiosSaham.pishNevis2);
        formData.append("ShenaseMeli", this.DataAxiosSaham.shenaseMeli);

        formData.append("SerialNumber", this.DataAxiosSaham.serialNumber);
        formData.append(
          "wwwtblImageIdLogo",
          this.DataAxiosSaham.wwwtblImageIdLogo,
        );
        formData.append(
          "wwwtblImageIdEmza1",
          this.DataAxiosSaham.wwwtblImageIdEmza1
            ? this.DataAxiosSaham.wwwtblImageIdEmza1
            : 0,
        );
        formData.append(
          "wwwtblImageIdEmza2",
          this.DataAxiosSaham.wwwtblImageIdEmza2
            ? this.DataAxiosSaham.wwwtblImageIdEmza2
            : 0,
        );
        formData.append(
          "MessageZeroScore",
          this.DataAxiosSaham.MessageZeroScore,
        );
        formData.append(
          "ShowMessageZeroScore",
          this.DataAxiosSaham.ShowMessageZeroScore,
        );
        formData.append("ShowScore", this.DataAxiosSaham.ShowScore);
        DataAxios_NoeSaham.ArryfildValue = formData;
        this.$PostFormData(DataAxios_NoeSaham).then((data) => {
          if (data.status == "Ok") {
            this.$mySweetDefaultTost(
              " ثبت موفق",
              "تغییرات شما با موفقیت ثبت گردید",
              "success",
              2000,
            );
          } else {
            this.$mySweetDefaultTost("خطایی رخ داده", data.msg, "danger", 2000);
          }
        });
      }
    },
    getSahamsettings() {
      var DataAxios_GetSaham = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/GetSahamSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      DataAxios_GetSaham.ArryfildValue = formData;
      this.$PostFormData(DataAxios_GetSaham).then((data) => {
        this.DataAxiosSaham = data.data;
        this.DataAxiosSaham.arzeshHarSahm = this.$Comma3ragham(
          this.DataAxiosSaham.arzeshHarSahm,
        );
        this.DataAxiosSaham.MessageZeroScore = data.noe.messageZeroScore;
        this.DataAxiosSaham.ShowMessageZeroScore =
          data.noe.showMessageZeroScore;
        this.DataAxiosSaham.ShowScore = data.noe.showScore;
      });
    },
    ChangeWwwtblNoeButtons() {
      this.DataAxiosButtons.wwwtblnoeId = this.DataAxiosButtons.wwwtblnoe.id;
      this.DataAxiosButtons.isPayment =
        this.DataAxiosButtons.wwwtblnoe.isPayment;
      this.DataAxiosButtons.isDebtor = this.DataAxiosButtons.wwwtblnoe.isDebtor;
      this.DataAxiosButtons.isTurnover =
        this.DataAxiosButtons.wwwtblnoe.isTurnover;
    },
    SetSettingButtons() {
      var DataAxios_Buttons = {
        ArryfildValue: "",
        Method: "Post",
        Action: "TanzimatNoe/UpdateSettings",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblNoeId", this.DataAxiosButtons.wwwtblnoeId);
      formData.append("isPayment", this.DataAxiosButtons.isPayment);
      formData.append("isDebtor", this.DataAxiosButtons.isDebtor);
      formData.append("isTurnover", this.DataAxiosButtons.isTurnover);
      DataAxios_Buttons.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Buttons).then((data) => {
        if (data.status == "Ok") {
          this.GetTashilatList();
          this.DataAxiosButtons = {};
          this.$mySweetDefaultTost(
            " ثبت موفق",
            "تغییرات شما با موفقیت ثبت گردید",
            "success",
            2000,
          );
        }
      });
    },
    SetTableSetting() {
      if (this.Account.Id > 0) {
        var DataAxios_Set = {
          ArryfildValue: "",
          Method: "Post",
          Action: "Bank/UpdateBank",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("BankId", this.Account.Id);
        formData.append("hesabNo", this.Account.HesabNo);
        formData.append("shebaNo", this.Account.ShebaNo);
        formData.append("cardNo", this.Account.CardNo.replaceAll("-", ""));
        formData.append("bankName", this.Account.BankName);
        formData.append("bankDetail", this.Account.BankDetail);
        DataAxios_Set.ArryfildValue = formData;
        this.$PostFormData(DataAxios_Set).then((data) => {
          if (data.status == "Ok") {
            this.$mySweetDefaultTost(
              " ثبت موفق",
              "اطلاع حساب بانکی شما با موفقیت ثبت گردید",
              "success",
              2000,
            );
            return;
          }
          this.$mySweetDefaultTost(
            "خطا در ثبت",
            "در ثبت اطلاعات خطایی رخ داد",
            "error",
            2000,
          );
        });
      } else {
        this.$mySweetDefaultTost(
          "عدم انتخاب بانک",
          "یانکی انتخاب نشده ، لطفا بانک خودرا انتخاب کنید",
          "error",
          2000,
        );
      }
    },
    GetTableBank() {
      var DataAxios_Get = {
        ArryfildValue: "",
        Method: "Get",
        Action: "Bank/GetBankList",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$GetData_Body(DataAxios_Get).then((res) => {
        this.BankList = res;
      });
    },
    GetResultBank() {
      if (this.Account.Id == 0) {
        this.$mySweetDefaultTost(
          "عدم انتخاب بانک",
          "لطفا یکی از بانک ها را انتخاب کنید",
          "",
          2000,
        );
        return;
      }
      var DataAxios_Set = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Bank/GetBankId",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("BankId", this.Account.Id);
      DataAxios_Set.ArryfildValue = formData;
      this.$PostFormData(DataAxios_Set).then((data) => {
        if (data.status == "Ok") {
          this.$mySweetDefaultTost(
            "موفق",
            "اطلاع حساب بانکی شما خوانده شد",
            "success",
            2000,
          );
          this.Account.HesabNo = data.data.hesabNo;
          this.Account.ShebaNo = data.data.shebaNo;
          this.Account.CardNo = data.data.cardNo;
          this.Account.BankName = data.data.bankName;
          this.Account.BankDetail = data.data.bankDetail;
        } else {
          this.$mySweetDefaultTost(
            "خطا",
            "خطایی در خواندن اطلاعات رخ داده ، لطفا کمی بعد تلاش کنید",
            "warning",
            2000,
          );
        }
      });
      // this.Account.Id=item.id
    },
    getBankId() {},
    ChangeActivePasswordSecurityMode(e) {
      var DataAxios_Upd = {
        ArryfildValue: "",
        Method: "Post",
        Action: "GetTblCustomer/UpdateActivePasswordSecurityMode",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append(
        "ActivePasswordSecurityMode",
        this.ActivePasswordSecurityMode,
      );
      formData.append("CustCode", Number(this.$session.get("CustCode")));

      DataAxios_Upd.ArryfildValue = formData;

      this.$PostFormData(DataAxios_Upd).then((res) => {
        if (res.status == "Ok") {
          this.$mySweetDefaultTost("موفق", res.message, "success", 2000);
          this.$SetActivePasswordSecurityMode(this.ActivePasswordSecurityMode);
        } else {
          this.$mySweetDefaultTost("خطا", res.message, "error", 2000);
        }
      });
    },
    clickUploader() {
      document.getElementById("Uploader").click();
    },
    openSahamUpload(id) {
      this.$nextTick(() => {
        const input = document.getElementById(id);
        if (input) input.click();
      });
    },
    onSahamUploadClick(event, id) {
      if (
        event.target.closest(
          ".fa-trash, .fa-download, a[download], input[type='file']",
        )
      ) {
        return;
      }
      this.openSahamUpload(id);
    },
    setLoginImgMode() {
      if (
        this.loginDefaultImageMode ||
        (!this.loginDefaultImageMode && this.IsImgLoginUploaded)
      ) {
        var DataAxios_loginImg = {
          ArryfildValue: "",
          Method: "Post",
          Action: "GetTblCustomer/UpdateLoginImgMode",
          Token: this.$session.get("TokenNetPa"),
        };
        const formData = new FormData();
        formData.append("imgMode", this.loginDefaultImageMode);
        formData.append("CustCode", Number(this.$session.get("CustCode")));

        DataAxios_loginImg.ArryfildValue = formData;
        this.$PostFormData(DataAxios_loginImg).then((res) => {
          if (res.status == "Ok") {
            this.$mySweetDefaultTost("موفق", res.message, "success", 2000);

            this.$setLoginImgMode(this.loginDefaultImageMode);
          } else {
            this.$mySweetDefaultTost("خطا", res.message, "error", 2000);
          }
        });
        this.IsImgLoginUploaded = false;
      }
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const img = new Image();
      const objectUrl = URL.createObjectURL(
        document.getElementById("Uploader").files[0],
      );
      img.onload = () => {
        if (img.width !== 500 || img.height !== 700) {
          this.$mySweetDefaultTost(
            "ابعاد تصویر نامعتبر است",
            "ابعاد تصویر باید دقیقاً 500×700 پیکسل باشد",
            "error",
            3000,
          );
        }
        URL.revokeObjectURL(objectUrl);
        e.target.value = "";
        return;
      };
      img.src = objectUrl;

      const allowedExtensions = ["jpg"];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.لطفا فرمت را به jpg  تغییر بدهید.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }

      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل مورد نظر بیشتر از 5 مگابایت است ",
          "error",
          3000,
        );
        return;
      } else {
        this.IsImgLoginUploaded = true;
        this.fileinfo = document.getElementById("Uploader").files[0];

        let formData = new FormData();
        formData.append("file", this.fileinfo);

        this.DataAxiosUpload.ArryfildValue = formData;

        this.loadingRender = true;

        this.$PostFormData(this.DataAxiosUpload).then((data) => {
          this.loadingRender = false;
          if (data.status === "ok") {
            this.setLoginImgMode();
          }
        });
      }
    },
    setRobot() {
      if (
        this.botSetting_Token.trim() == "" ||
        this.botSetting_UserName.trim() == "" ||
        this.botSetting_AboutUs.trim() == ""
      ) {
        this.$mySweetDefaultTost(
          "خطا",
          "لطفا تمامی فیلدها را پر کنید",
          "error",
          2000,
        );
        return;
      } else {
        var DataAxios_Robot = {
          ArryfildValue: "",
          Method: "Post",
          Action: "GetTblCustomer/UpdateRobotSetting",
          Token: this.$session.get("TokenNetPa"), // شماعی 1405/07/14 : API حالا فقط کارمند صندوق را قبول می‌کند
        };
        const formData = new FormData();

        formData.append("BotToken", this.botSetting_Token);
        formData.append("BotUserName", this.botSetting_UserName);
        formData.append("BotAboutUsText", this.botSetting_AboutUs);
        formData.append("CustCode", Number(this.$session.get("CustCode")));

        DataAxios_Robot.ArryfildValue = formData;

        this.$PostFormData(DataAxios_Robot).then((res) => {
          if (res.status == "Ok") {
            this.$mySweetDefaultTost("ثبت موفق", res.message, "success", 2000);
          } else {
            this.$mySweetDefaultTost("خطا", res.message, "message", 2000);
          }
        });
      }
    },
  },
  created() {
    this.$GetAppsettingsAsync();
    var botSettingArray = this.$GetBotSetting();
    this.botSetting_Token = botSettingArray.token;
    this.botSetting_UserName = botSettingArray.userName;
    this.botSetting_AboutUs = botSettingArray.aboutUs;
    this.EnableRobot = sessionStorage.getItem("EnableRobot");
    this.readMenus();
    this.GetTaahodatList();
    this.GetTashilatList();
    this.GetFile();
    this.getSahamsettings();
    this.GetTableBank();
  },
  watch: {
    EditMode() {
      this.$nextTick(() => {
        if (this.toolbarPinned) this.updateGatewayPinBox();
      });
    },
  },
  updated() {
    //k.hr
  },
  mounted() {
    this.$nextTick(() => {
      const toolbar =
        this.$refs.gatewayAnchor &&
        this.$refs.gatewayAnchor.querySelector(".gw-toolbar");
      if (toolbar) this.toolbarHeight = toolbar.offsetHeight;
      this.observeGatewayToolbar();
    });
  },
  beforeDestroy() {
    if (this.toolbarObserver) this.toolbarObserver.disconnect();
    if (this.anchorResizeObserver) this.anchorResizeObserver.disconnect();
  },
};
</script>
<style scoped>
.gw-toolbar-anchor {
  margin-bottom: 8px;
}

.gw-sentinel {
  height: 1px;
  margin: 0;
  pointer-events: none;
}

.gw-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: rgba(247, 249, 251, 0.96);
}

.gw-toolbar.is-fixed {
  position: fixed;
  z-index: 40;
  margin: 0;
  box-shadow: 0 14px 28px rgba(41, 52, 95, 0.16);
}

.gw-toolbar.is-editing {
  border-color: rgba(5, 184, 200, 0.35);
  background: linear-gradient(100deg, rgba(237, 247, 251, 0.98), #fff 62%);
}

.gw-summary {
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
}

.gw-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.gw-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 34px;
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color 180ms ease,
    background 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.gw-btn:focus {
  outline: none;
}

.gw-btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.gw-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.gw-btn--edit,
.gw-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

.gw-btn--edit:not(:disabled):hover,
.gw-btn--ghost:not(:disabled):hover {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.gw-btn--save {
  min-height: 34px;
  padding: 6px 14px;
  color: #fff;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 10px 20px rgba(41, 52, 95, 0.16);
}

.gw-btn--save:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(41, 52, 95, 0.22);
}

.gw-empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.gw-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0.9rem;
}

.gw-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 1rem 1.05rem 0.95rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.gw-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.75rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #e8eef2;
}

.gw-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.gw-card__name-input {
  flex: 1 1 10rem;
  min-width: 0;
  height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

.gw-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  color: #8a6414;
  font-size: 12px;
  font-weight: 800;
  border-radius: 999px;
  background: #fff4d6;
}

.gw-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.gw-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.gw-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.gw-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.gw-card.is-editing .gw-card__field {
  flex-direction: column;
  align-items: stretch;
  gap: 0.35rem;
}

.gw-card__field input[type="text"] {
  width: 100%;
  height: 40px;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

.gw-card__field input[type="text"][dir="ltr"] {
  text-align: left;
}

.gw-card__name-input:focus,
.gw-card__field input[type="text"]:focus {
  outline: none;
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.gw-card__flags {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  margin-top: auto;
  padding-top: 0.7rem;
  border-top: 1px solid #e8eef2;
}

.gw-card__flag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0;
  cursor: pointer;
}

.gw-card__flag.is-disabled {
  cursor: default;
}

.gw-card__flag > span:first-child {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.gw-card__flag-ctrl {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.gw-card__flag-state {
  min-width: 52px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
}

.gw-card__flag-state.is-on {
  color: #068997;
}

.gw-card__flag-state.is-off {
  color: #8b98a8;
}

.gw-switch {
  position: relative;
  display: inline-flex;
  margin: 0;
  cursor: pointer;
}

.gw-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}

.gw-switch__track {
  position: relative;
  display: block;
  width: 36px;
  height: 20px;
  border-radius: 999px;
  background: #d5dee6;
  transition: background 180ms ease;
}

.gw-switch__track::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(19, 36, 58, 0.22);
  transition: transform 180ms ease;
}

.gw-switch input:checked + .gw-switch__track {
  background: linear-gradient(110deg, #29345f, #05b8c8);
}

.gw-switch input:checked + .gw-switch__track::after {
  transform: translateX(-16px);
}

.gw-switch input:focus-visible + .gw-switch__track {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.22);
}

.gw-switch input:disabled + .gw-switch__track {
  cursor: not-allowed;
  opacity: 0.55;
}

.gw-card__flag.is-disabled .gw-switch {
  cursor: not-allowed;
}

.sys-list {
  display: flex;
  flex-direction: column;
}

.sys-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 2px;
  border-bottom: 1px solid #e8eef2;
}

.sys-row:last-child {
  border-bottom: 0;
  padding-bottom: 2px;
}

.sys-copy {
  min-width: 0;
}

.sys-title {
  display: block;
  color: #31465f;
  font-size: 14px;
  font-weight: 700;
}

.sys-hint {
  display: block;
  margin-top: 4px;
  color: #8b98a8;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.7;
}

.sys-file {
  display: inline-block;
  margin-top: 8px;
  color: #596a7d;
  font-size: 12px;
  font-weight: 600;
}

.sys-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.sys-state {
  min-width: 52px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.sys-state.is-on {
  color: #068997;
}

.sys-state.is-off {
  color: #8b98a8;
}

@media (max-width: 767px) {
  .gw-toolbar,
  .sys-row {
    flex-direction: column;
    align-items: stretch;
  }

  .gw-actions,
  .sys-actions {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .gw-btn--edit,
  .gw-btn--save {
    flex: 1;
  }

  .gw-cards {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .gw-btn,
  .gw-switch__track,
  .gw-switch__track::after {
    transition: none;
  }

  .gw-btn--save:not(:disabled):hover {
    transform: none;
  }
}

.acc-form {
  display: grid;
  gap: 12px;
  width: 100%;
  max-width: 840px;
}

.acc-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  align-items: end;
}

.acc-field {
  min-width: 0;
  text-align: right;
}

.acc-field--span2 {
  grid-column: span 2;
}

.acc-field--wide {
  grid-column: 1 / -1;
}

.acc-field label {
  display: block;
  margin-bottom: 6px;
  color: #31465f;
  font-size: 12px;
  font-weight: 700;
}

.acc-input,
.acc-field .form-control {
  width: 100%;
  min-height: 40px;
  height: 40px;
  padding: 0.45rem 0.7rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: none;
}

.acc-input:focus,
.acc-field .form-control:focus {
  outline: none;
  border-color: #05b8c8;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.acc-input--muted {
  color: #8b98a8;
  background: #f5f7fb;
}

.acc-input.acc-notes {
  min-height: 96px;
  height: auto;
  resize: vertical;
}

.acc-field--date >>> .vpd-main {
  display: block;
  width: 100%;
}

.acc-field--date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: none;
}

.acc-field--date >>> .vpd-input-group:focus-within {
  border-color: #05b8c8;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.acc-field--date >>> .vpd-input-group input,
.acc-field--date >>> .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

.acc-field--date >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #068997;
  border: none;
  background: #e9f9fb;
}

.acc-switch--start {
  grid-column: 1;
}

.acc-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  margin: 0;
  padding: 8px 12px;
  color: #31465f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  border: 1px solid #e8eef2;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.acc-hint {
  margin: 0;
  padding: 8px 12px;
  color: #b44f46;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.7;
  border: 1px solid #f0d4d1;
  border-radius: 10px;
  background: #fcefed;
}

.acc-actions {
  display: flex;
  justify-content: flex-start;
}

.acc-actions .gw-btn--save {
  min-width: 148px;
}

.acc-form--saham {
  max-width: none;
}

.acc-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.acc-saham {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}

.acc-uploaders {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.acc-saham-panel {
  min-width: 0;
}

.acc-saham-panel__title {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.85rem;
  color: #29345f;
  font-size: 13px !important;
  font-weight: 800;
}

.acc-saham-upload {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  min-height: 72px;
  padding: 14px 16px;
  border: 1px solid #eef1f6;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
  cursor: pointer;
}

.acc-saham-upload:hover .acc-saham-upload__preview {
  border-color: #05b8c8;
  background: #e7f7fa;
}

.acc-saham-upload__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 0.15rem;
}

.acc-saham-upload__title {
  color: #1c2b3d;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.6;
}

.acc-saham-upload__hint {
  color: #068997;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.acc-saham-upload__preview {
  position: relative;
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  overflow: hidden;
  border: 1px dashed #b7c4d6;
  border-radius: 14px;
  background: #eef2fb;
}

.acc-saham-upload.has-file .acc-saham-upload__preview {
  border-style: solid;
  border-color: #dbe5eb;
}

.acc-saham-upload__icon,
.acc-saham-upload__plus {
  position: absolute;
  z-index: 1;
  color: #5b6f8a;
  pointer-events: none;
}

.acc-saham-upload__icon {
  top: 50%;
  left: 46%;
  font-size: 18px;
  transform: translate(-50%, -50%);
}

.acc-saham-upload__plus {
  right: 6px;
  bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #fff;
  font-size: 8px;
  border-radius: 50%;
  background: #05b8c8;
}

.acc-saham-upload.has-file .acc-saham-upload__icon,
.acc-saham-upload.has-file .acc-saham-upload__plus {
  display: none;
}

.acc-saham-upload >>> .container-fluid,
.acc-saham-upload >>> .container-fluid > .row,
.acc-saham-upload >>> .container-fluid > .row > [class*="col-"] {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.acc-saham-upload >>> .container-fluid > .row {
  position: relative;
}

.acc-saham-upload >>> .col-12.text-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  overflow: hidden;
}

.acc-saham-upload >>> .col-12.text-center img,
.acc-saham-upload >>> .col-12.text-center img.w-100 {
  display: block;
  width: 52px !important;
  height: 52px !important;
  max-width: 52px !important;
  max-height: 52px !important;
  object-fit: cover;
  border-radius: 14px;
}

.acc-saham-upload >>> img[src*="OHUploader"] {
  opacity: 0;
}

.acc-saham-upload >>> .col-12:not(.text-center) {
  position: absolute;
  top: -10px;
  left: -6px;
  z-index: 2;
  width: auto;
  height: auto;
}

.acc-saham-upload >>> .col-12.p-3.text-center.font-weight-bold {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0 !important;
  font-size: 0;
  line-height: 0;
  text-align: left;
}

.acc-saham-upload >>> .col-12.p-3.text-center.font-weight-bold .fas {
  float: none !important;
  margin: 0 2px !important;
  font-size: 12px;
}

@media (max-width: 991px) {
  .acc-grid,
  .acc-grid--2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .acc-saham,
  .acc-uploaders {
    grid-template-columns: minmax(0, 1fr);
  }

  .acc-field--span2,
  .acc-field--wide {
    grid-column: 1 / -1;
  }
}

@media (max-width: 767px) {
  .acc-form {
    max-width: none;
  }

  .acc-grid,
  .acc-grid--2,
  .acc-saham,
  .acc-uploaders {
    grid-template-columns: minmax(0, 1fr);
  }

  .acc-field--span2,
  .acc-field--wide {
    grid-column: auto;
  }

  .acc-actions {
    justify-content: stretch;
  }

  .acc-actions .gw-btn--save {
    width: 100%;
  }

  .acc-form--saham {
    overflow-x: hidden;
  }

  .acc-form--saham .acc-saham {
    gap: 0.75rem;
  }

  .acc-form--saham .acc-saham-panel {
    padding: 0.95rem 1rem 0.9rem;
    border: 1px solid #e8eef2;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
  }

  .acc-form--saham .acc-field label {
    white-space: normal;
    line-height: 1.5;
  }

  .acc-form--saham .acc-input.text-center,
  .acc-form--saham .acc-input[dir="ltr"] {
    text-align: left;
  }

  .acc-form--saham .acc-switch {
    align-items: flex-start;
    min-height: 44px;
    padding: 0.7rem 0.8rem;
  }

  .acc-form--saham .acc-switch > span:first-child {
    min-width: 0;
    white-space: normal;
    line-height: 1.6;
  }

  .acc-form--saham .acc-switch .gw-switch {
    flex: 0 0 auto;
    margin-top: 0.15rem;
  }

  .acc-saham-upload {
    min-height: 68px;
    padding: 12px 14px;
  }

  .acc-saham-upload__title {
    font-size: 13px;
  }
}
</style>
<style>
#nav-Account .acc-field--date .vpd-main {
  display: block;
  width: 100%;
}

#nav-Account .acc-field--date .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
}

#nav-Account .acc-field--date .vpd-input-group input,
#nav-Account .acc-field--date .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
}

#nav-Account .acc-field--date .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: auto !important;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #068997;
  border: none;
  background: #e9f9fb;
}
</style>
